<template>
  <div id="serviceNotAvailableDiv">
    <div
      id="serviceNotAvailable1"
      style="position: fixed; border-radius: 50%"
    ></div>
    <div
      id="serviceNotAvailable2"
      style="position: fixed; border-radius: 50%"
    ></div>

    <div
      id="lastPage"
      class="fixed-center2"
      style="text-align: center; z-index: 2; width: 100%; opacity: 0"
    >
      <p
        class="headline px-2"
        style="
          z-index: 2;
          width: 100%;
          word-break: keep-all;
          color: white;
          position: absolute;
          top: -43px;
        "
      >
        Seat Booking
      </p>

      <v-img
        :src="`${this.iconPath}nlb-logo-only-white.png`"
        width="130"
        height="130"
        style="margin: auto"
      ></v-img>
    </div>

    <div
      class="fixed-center2"
      style="text-align: center; z-index: 2; width: 100%"
    >
      <v-icon v-show="!showMessage" style="color: white; font-size: 80px">{{
        loadingIcon
      }}</v-icon>
    </div>

    <div class="header">
      <p
        v-resize="onResize"
        id="lblMessage"
        style="position: absolute; width: 100%; color: white"
        class="px-3"
      >
        <em>{{ serviceNotAvailableMessage }}</em>
      </p>

      <div
        v-show="showUfo"
        style="position: absolute; bottom: 3px; left: 120px"
      >
        <v-icon color="white">mdi-ufo-outline</v-icon>
      </div>

      <div>
        <svg
          class="waves"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
          shape-rendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>
          <g class="parallax">
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="0"
              fill="rgba(255,255,255,0.7"
            />
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="3"
              fill="rgba(255,255,255,0.5)"
            />
            <use
              xlink:href="#gentle-wave"
              x="48"
              y="5"
              fill="rgba(255,255,255,0.3)"
            />
            <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
          </g>
        </svg>
      </div>
    </div>

    <!-- Wave 2 -->
    <!-- <div class="ocean">
      <div class="wave"></div>
      <div class="wave"></div>
    </div>-->
  </div>
</template>

<script>
import animator from "@/helpers/animator";

export default {
  name: "ServiceNotAvailable",
  data: () => ({
    showMessage: false,
    showUfo: false,
    loadingIcon: null,
    serviceNotAvailableMessage: "",
    transitions: [
      {
        backgroundImage: "radial-gradient(circle, #F44336, #B71C1C)",
        statusBarColor: "#B71C1C",
        icon: "mdi-cellphone-iphone",
      }, //Red
      {
        backgroundImage: "radial-gradient(circle, #FF9800, #E65100)",
        statusBarColor: "#E65100",
        icon: "mdi-qrcode-scan",
      }, //Orange
      {
        backgroundImage: "radial-gradient(circle, #FFEB3B, #F57F17)",
        statusBarColor: "#FFEB3B",
        icon: "mdi-map-search",
      }, //Yellow
      {
        backgroundImage: "radial-gradient(circle, #4CAF50, #1B5E20)",
        statusBarColor: "#1B5E20",
        icon: "mdi-seat",
      }, //Green
      {
        backgroundImage: "radial-gradient(circle, #2196f3, #0d47a1)",
        statusBarColor: "#0d47a1",
        icon: null,
      }, //Blue
    ],
    // transitions: [
    //   "radial-gradient(circle, #2196f3, #0d47a1)", //Blue
    //   "radial-gradient(circle, #424242, black)", //Black
    //   "radial-gradient(circle, #FFEB3B, #F57F17)", //Yellow
    //   "radial-gradient(circle, #9C27B0, #4A148C)", //Purple
    //   "radial-gradient(circle, #F44336, #B71C1C)", //Red
    //   "radial-gradient(circle, #4CAF50, #1B5E20)", //Green
    //   "radial-gradient(circle, #607D8B, #263238)", //Blue gray
    //   "radial-gradient(circle, #FF9800, #E65100)" //Orange
    // ]
  }),
  mounted() {
    this.setContentHeight();

    this.setStatusBackgroundBarColor("#FFFFFF");

    this.serviceNotAvailableMessage = window.$msg.serviceNotAvailable;

    setTimeout(() => {
      this.startLoading();
    }, 500);
  },
  methods: {
    startLoading() {
      this.ripple(0);
    },
    onResize() {
      document.getElementById("lblMessage").style.top =
        window.innerHeight > 500 ? "-50px" : "0";

      this.setContentHeight();
    },
    setContentHeight() {
      document.getElementById("serviceNotAvailableDiv").style.height =
        this.heights().screen + "px";
    },
    ripple(count) {
      if (count >= this.transitions.length) {
        return;
      }

      let transitionIndex =
        this.transitions.length > count
          ? count
          : count % this.transitions.length;
      let transition = this.transitions[transitionIndex];

      setTimeout(() => {
        this.loadingIcon = this.transitions[transitionIndex].icon;

        if (count === this.transitions.length - 1) {
          document.getElementById("lastPage").style.opacity = 1;
        }
      }, 150);

      let loadingEleId = "serviceNotAvailable" + (count % 2 === 0 ? "1" : "2");

      let completeCallback = null;
      if (count < this.transitions.length - 1) {
        completeCallback = () => {
          this.setStatusBackgroundBarColor(transition.statusBarColor);
          this.ripple(++count);
        };
      } else {
        completeCallback = () => {
          this.setStatusBackgroundBarColor(transition.statusBarColor);
          document.getElementById(
            "serviceNotAvailableDiv"
          ).style.backgroundImage = "radial-gradient(circle, #2196f3, #0d47a1)";

          document.getElementById("serviceNotAvailable1").style.opacity = 0;
          document.getElementById("serviceNotAvailable2").style.opacity = 0;
          this.showMessage = true;

          setTimeout(() => {
            this.showUfo = true;
            setTimeout(() => {
              this.showUfo = false;
            }, 8000);
          }, 16000);
        };
      }

      animator.rippleTransition(
        loadingEleId,
        loadingEleId,
        300,
        0,
        28,
        null,
        transition.backgroundImage,
        true,
        false,
        completeCallback
      );
    },
  },
};
</script>

<style>
/* #2196f3, #0d47a1 */

.header {
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: white;
  border-bottom: 0px solid white;
}

.waves {
  position: relative;
  width: 100%;
  height: 15vh;
  margin-bottom: -7px;
  /*Fix for safari gap*/
  min-height: 100px;
  max-height: 150px;
}

/* Animation */
.parallax > use {
  animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
}
.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: 5s;
}
.parallax > use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: 7s;
}
.parallax > use:nth-child(3) {
  animation-delay: -4s;
  animation-duration: 9s;
}
.parallax > use:nth-child(4) {
  animation-delay: -5s;
  animation-duration: 11s;
}
@keyframes move-forever {
  0% {
    transform: translate3d(-90px, 0, 0);
  }
  100% {
    transform: translate3d(85px, 0, 0);
  }
}
/*Shrinking for mobile*/
@media (max-width: 768px) {
  .waves {
    height: 60px;
    min-height: 60px;
  }
}

/* Wave 2 */
/* .ocean {
  height: 0%;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #ffffff;
}

.wave {
  background: url(../assets/images/wave.svg) repeat-x;
  position: absolute;
  top: -138px;
  width: 6400px;
  height: 198px;
  animation: wave 7s cubic-bezier(0.36, 0.45, 0.63, 0.53) infinite;
  transform: translate3d(0, 0, 0);
}

.wave:nth-of-type(2) {
  top: -115px;
  animation: wave 7s cubic-bezier(0.36, 0.45, 0.63, 0.53) -0.125s infinite,
    swell 7s ease -1.25s infinite;
  opacity: 1;
}

@keyframes wave {
  0% {
    margin-left: 0;
  }
  100% {
    margin-left: -1600px;
  }
}

@keyframes swell {
  0%,
  100% {
    transform: translate3d(0, -25px, 0);
  }
  50% {
    transform: translate3d(0, 5px, 0);
  }
} */
</style>